import {AsyncJobChatHistoryStatus} from 'shared/models/task/chat';

export function isAsyncJobInProgress(status: AsyncJobChatHistoryStatus): boolean {
  return status === undefined || [AsyncJobChatHistoryStatus.queued, AsyncJobChatHistoryStatus.running].includes(status);
}
